import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { EnvService } from '../services/env/env.service';
import { Loader } from '../services/loader/loader.service';
import { finalize } from 'rxjs/operators';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private env: EnvService,
    private loader: Loader
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentToken = this.authService.currentTokenValue;
    this.loader.isLoadingSubject.next(true);
    let headers: { [header: string]: string } = {
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
    };

    if (!(request.body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }

    if (
      (currentToken && request.url.startsWith(this.env.url)) ||
      (currentToken && request.url.startsWith(this.env.url_public))
    ) {
      headers['Authorization'] = `Bearer ${currentToken}`;
    }

    request = request.clone({
      setHeaders: headers,
    });
    return next.handle(request).pipe(
      finalize(() => {
        this.loader.isLoadingSubject.next(false);
      })
    );
  }
}
